import script from "./AltarRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./AltarRoom.vue?vue&type=script&setup=true&lang=js"

import "./AltarRoom.vue?vue&type=style&index=0&id=ca18634a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca18634a"]])

export default __exports__